export default {
    indexBranches:   { method: 'get',    url: 'branches' },
    createBranch:     { method: 'post',   url: 'branches'},
    updateBranch:     { method: 'put',    url: 'branches/{id}'},
    destroyBranch:    { method: 'delete', url: 'branches/{id}'},
}